// extracted by mini-css-extract-plugin
export default {"page_list":"index_page_list_K2AAb clearfix","current":"index_current_sec-k"};